import $ from 'jquery';
window.jQuery = $;
window.$ = $;

import Rails from 'rails-ujs';
import Turbolinks from 'turbolinks';
Rails.start();
Turbolinks.start();

require('bootstrap/dist/js/bootstrap')

import '../src/javascript/granim.min.js';
import '../src/javascript/blog-scripts.js';